"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgCircleArrowRight = function SvgCircleArrowRight(props) {
  return _react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _react.default.createElement("path", {
    d: "M15.96 12.235v.001c0 .002-.003.003-.004.005a.504.504 0 0 1-.104.158l-3.5 3.5a.502.502 0 0 1-.707 0 .499.499 0 0 1 0-.707l2.646-2.647H8.498a.5.5 0 0 1 0-1h5.793L11.645 8.9a.499.499 0 0 1 0-.707.499.499 0 0 1 .707 0l3.5 3.5a.484.484 0 0 1 .133.288.483.483 0 0 1-.025.255M12.002 0C5.368 0 0 5.368 0 11.993v.01c.01 6.626 5.368 11.993 12.002 11.993 6.626 0 11.995-5.377 11.995-12.003C23.997 5.368 18.628 0 12.002 0",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

var _default = SvgCircleArrowRight;
exports.default = _default;